import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { CookieConsentProvider } from './context/CookieConsentProvider'
import './index.css'
import App from './App.tsx'

export function createAppInitializer() {
  return function initializeApp() {
    const root = document.getElementById('root')

    if (!root) {
      console.error('Root element not found. Make sure there is a div with id="root" in your HTML.')
      throw new Error('Root element not found')
    }

    createRoot(root).render(
      <StrictMode>
        <HelmetProvider>
          <CookieConsentProvider>
            <App RouterComponent={BrowserRouter} />
          </CookieConsentProvider>
        </HelmetProvider>
      </StrictMode>,
    )
  }
}

// Only initialize the app if not running in test environment
if (!(import.meta as { vitest?: boolean }).vitest && (typeof process === 'undefined' || process.env.NODE_ENV !== 'test')) {
  createAppInitializer()();
}
